import _ from 'lodash';
import React, { useContext, useEffect } from 'react';
import { FormContext } from '../../cnr/contexts/FormContext';
import { uniqueKey } from '../../common/keys';
import { gEnums, listTypes } from '../../enums/globalEnums';
import { propDataOpts, spp } from '../../viewSettings/settingsProps/settingsAll';
import HtmlEditor from './elements/HtmlEditor';
import FormElements from './props/FormElements';
import { ComponentContext } from '../../cnr/contexts/ComponentContext';
import { useViewProps } from 'global/cnr/contexts/useHelpers/useViewProps';

// FormItems > FormElements > FormItemProp > FormItem
/**
 * 
 * @param {object} props 
 * @returns the formItems
 */
const FormItems = () => {

  // formContext
  const formContext = useContext(FormContext)
  const { form_state, form_handlers, formParent_contexts } = formContext ?? {}
  const { settings } = formParent_contexts ?? {}
  const { homeSettings } = settings ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { logging } = homeSettings_global ?? {}

  const {
    currentFip,
    data_localForm,
    formProps,
    viewProps_normal,
    vpsa,
    formKey
  } = form_state

  let {
    data_init,
    settingsType,
    viewProps,
    propSectionProps
  } = formProps ?? {}

  if (logging && logging.allowLogging && logging.logFormInitData) { console.log('logging >', 'data_init', data_init) }

  if (vpsa) { viewProps = vpsa }

  // see if viewProps has 'dataListType'
  if (viewProps_normal && viewProps_normal['dataListType']) {
    if (data_localForm && data_localForm['dataListType'])
      switch (data_localForm['dataListType']) {
        case gEnums.dataListTypes.view:
          viewProps_normal['view'] = spp('view', propDataOpts(false, gEnums.formItemTypes.select, listTypes.dataCollection))
          break;
        default:
        // nothing
      }
  }

  const _viewProps = useViewProps({ form_state, viewProps, propSectionProps })


  // IMPORTANT: Form Items - Update the form item data
  useEffect(() => {
    if (data_init) {
      form_handlers.handleUpdateLocalFormData(data_init)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [data_init, settingsType]);

  useEffect(() => {
    form_handlers.handleSet_viewProps(_viewProps)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [viewProps, formKey]);

  // IMPORTANT: Form Items - All Form Item Changes 
  /** Triggered when any of the element changes value */
  const handleFormItemChange = (e, data, items, arrayItems) => {
    form_handlers.handleFormItemChange(e, data, items, arrayItems)
  }

  if (currentFip) {
    return <HtmlEditor
      key={uniqueKey('htmle', currentFip.propname)}
      currentFip={currentFip}
      handleUpdate={handleFormItemChange}
      handleEditor={form_handlers.handleEditor}
    />
  }

  return viewProps_normal ? <FormElements /> : <div></div>

}

export default FormItems